import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { Col } from "react-bootstrap";
import { Api } from "../../utils/api";
import { MaterialSelect } from "../../components/select-field.component";
import { CheckboxWithLabel } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

const plansOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/plans")
    .then((res) => res.data)
    .then((res) => {
      res.push({ id: 0, name: "Todos os planos" });
      res.push({ id: 100, name: "Todos os planos pagos" });
      res.push({ id: 1000, name: "Planos oferta" });
      return res;
    })
    .then(optionsToSelect);
};

const request_modeOptionsToSelect = (options) => {
  return options.map((option) => ({
    value: option.request_mode,
    label: option.label,
  }));
};

const request_modeOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/request_mode")
    .then((res) => res.data)
    .then(request_modeOptionsToSelect);
};

const motivesOptionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.motive }));
};

const motivesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/no_requests_motives")
    .then((res) => res.data)
    .then((res) => {
      res.push({ id: 0, motive: "Todos os motivos" });
      return res;
    })
    .then(motivesOptionsToSelect);
};

export const PaymentFilterForm = ({ onChange, searchValues }) => (
  <Col>
    <Formik
      initialValues={{ ...searchValues }}
      onSubmit={handleSubmitting(onChange)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      render={({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Grid container alignItems="center">
              <Grid item md={8}>
                <MaterialSelect
                  name="plan_id"
                  placeholder="plan_id"
                  label="Plano"
                  value={"" + values.plan_id}
                  onBlur={setFieldTouched}
                  onChange={setFieldValue}
                  optionsFetcher={plansOptionsPromise}
                />

                <MaterialSelect
                  name="request_mode"
                  placeholder="request_mode"
                  label="Modo de Encaminhamento"
                  value={"" + values.request_mode}
                  onBlur={setFieldTouched}
                  onChange={setFieldValue}
                  optionsFetcher={request_modeOptionsPromise}
                />
              </Grid>
              <Grid item md={12}>
                <Field
                  name="with_debts"
                  Label={{ label: "Com dívidas" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.with_debts}
                />
                <p class="filter_with_debts_paragrah">
                  (sem pagamentos nos últimos 45 dias)
                </p>
                <Field
                  name="no_requests"
                  Label={{ label: "Sem acesso a pedidos" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.no_requests}
                />
                {values.no_requests && (
                  <MaterialSelect
                    name="motive_id"
                    placeholder="motive_id"
                    label="Motivo"
                    id="motive_combobox"
                    value={"" + values.motive_id}
                    onBlur={setFieldTouched}
                    onChange={setFieldValue}
                    optionsFetcher={motivesOptionsPromise}
                  />
                )}
                <Field
                  name="dispersed_requests"
                  Label={{ label: "Aceita pedidos dispersos" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.dispersed_requests}
                />
                <Field
                  name="exclusive_requests"
                  Label={{ label: "Aceita pedidos encaminhados" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.exclusive_requests}
                />
                <Field
                  name="exclusive_requests_false"
                  Label={{ label: "Não aceita pedidos encaminhados" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.exclusive_requests_false}
                />
                <Field
                  name="force_requests"
                  Label={{ label: "Com potencial de angariação" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.force_requests}
                />
                <Field
                  name="disabled_payment"
                  Label={{ label: "Próximas cobranças desativas" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={values.disabled_payment}
                />
                <Field
                  name="any_limit_establishments_requests"
                  Label={{ label: "Com limite de 3 aceitações mensais" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.any_limit_establishments_requests}
                />
                <Field
                  name="limit_establishments_requests"
                  Label={{
                    label:
                      "Com limite de 3 aceitações mensais (entidades com limite atingido)",
                  }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.limit_establishments_requests}
                />
                <Field
                  name="auto_accepted"
                  Label={{ label: "Com encaminhamento imediato" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.auto_accepted}
                />
                <Field
                  name="no_auto_accept"
                  Label={{ label: "Sem encaminhamento imediato" }}
                  component={CheckboxWithLabel}
                  onChange={setFieldValue}
                  value={"" + values.no_auto_accept}
                />
              </Grid>
            </Grid>
            <Button variant="contained" type="submit" size="small">
              Filtrar
            </Button>
          </form>
        );
      }}
    />
  </Col>
);
